import { getParser } from 'bowser';

export const createAudioContext = async () => {
    await window.navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false
    });
    if (window.AudioContext) {
        return new AudioContext();
    } else if (window.webkitAudioContext) {
        return new window.webkitAudioContext();
    }

    throw new Error(`Can't create new AudioContext`);
}

export const testAudioContext = (audioContext) => {
    if (!audioContext) throw new Error('No AudioContext');

    if (parseInt(audioContext.sampleRate) <= 16000) {
        let agent = getParser(window.navigator.userAgent);
        if (
            agent.isBrowser("Safari") &&
            agent.satisfies({ safari: "<14.0.2" })
        ) {
            throw new Error('Sample rate not supported. Probably using Bluetooth on an old version of Safari. Please turn off Bluetooth or update your browser.');
        }
    }

    return true;
}

export const getAudioTrack = async (constraints) => {
    let audioConstraints = {
        autoGainControl: false,
        echoCancellation: false,
        noiseSuppression: false,
        ...constraints
    };

    if (audioConstraints.deviceId && audioConstraints.deviceId !== 'default') {
        audioConstraints.deviceId = { exact: audioConstraints.deviceId };
    }

    let mediaStream = await window.navigator.mediaDevices.getUserMedia({
        audio: audioConstraints,
        video: false
    });

    let tracks = mediaStream.getAudioTracks();
    let track = tracks[0];

    return track;
}

export const getVideoTrack = async (constraints) => {
    let videoConstraints = {
        width: 1920,
        height: 1080,
        ...constraints
    };

    if (videoConstraints.deviceId && videoConstraints.deviceId !== 'default') {
        videoConstraints.deviceId = { exact: videoConstraints.deviceId };
    }

    let mediaStream = await window.navigator.mediaDevices.getUserMedia({
        audio: false,
        video: videoConstraints
    });

    let tracks = mediaStream.getVideoTracks();
    let track = tracks[0];

    return track;
}

export const filterDevices = (devices, type) => {
    if (!devices) return [];
    if (!(devices instanceof Array)) return [];

    return devices.filter(device => {
        return device.kind === type;
    });
}

export const createMediaStream = (arrayOfMediaTracks = [], clone = false) => {
    let stream = new MediaStream();
    arrayOfMediaTracks.forEach(track => {
        if (track) {
            if (clone) {
                stream.addTrack(track.clone());
            }
            else {
                stream.addTrack(track);
            }
        }
    })
    return stream;
}

export const hasMediaRecorder = () => {
    if (window.MediaRecorder && window.MediaRecorder.isTypeSupported) return true;
    return false;
}